
import PropTypes from 'prop-types'
import { FacilityPageQuery } from '@layouts/facility'

const FacilityPage = ({ query }) => {
  return (
    <FacilityPageQuery {...query} />
  )
}

FacilityPage.getInitialProps = async ({ query }) => ({ query })

FacilityPage.propTypes = {
  query: PropTypes.object,
}

export default FacilityPage
